import React from "react";
import { Link } from "react-router-dom";
import BackgroundWrapper from "../components/BackgroundWrapper";


export default function CLevelCoaching() {
  return (
    <BackgroundWrapper>
     
      <div className="pt-8 pb-20 px-4 min-h-screen flex justify-center">
        <div className="max-w-5xl bg-white/90 backdrop-blur-md rounded-3xl shadow-2xl p-8 md:p-12">
          <Link
            to="/programs"
            className="mb-8 inline-flex items-center text-blue-600 hover:text-blue-700 font-semibold"
          >
            ← Back to Programs
          </Link>

          <h1 className="text-xl sm:text-4xl font-bold text-slate-800 mb-8 text-center">
            C-Level Mentoring & Coaching
          </h1>

          <p className="sm:text-lg text-sm text-slate-700 mb-6 leading-relaxed">
            Tailored for <strong>senior executives and board members</strong> facing complex challenges
            or adapting to new business realities.  
            The process is both advisory and transformational.
          </p>

          <h3 className="sm:text-2xl text-xl font-semibold text-slate-800 mb-4">Approach</h3>
          <p className="text-slate-700 mb-6 sm:text-lg text-sm">
            Through <strong>one-to-one or group mentoring</strong>, leaders work with a trusted advisor
            to explore strategic dilemmas, leadership identity, and personal growth opportunities.
            Coaching helps executives uncover their own path forward by asking the right questions;
            mentoring provides expert insight as a sounding board.
          </p>

          <p className="text-slate-700 mb-6 sm:text-lg text-sm">
            Accredited internationally, the program follows <strong>ICF-certified coaching</strong> standards,
            offering executives a confidential environment to gain clarity and confidence in decision-making.
          </p>
        </div>
      </div>
    </BackgroundWrapper>
  );
}
